import React, { Component } from "react";
import { observer } from "mobx-react";
import { fn_change_step } from "../../../../function/FnBodyStep";
import {fn_setTimeListDisabled} from "function/FnBodySetting"
import { fn_get_customer_ygy_pop, fn_set_customer_ygy_pop } from "../../../../function/FnBodyDetail";
import { fn_bridge_order_accept } from "../../../../function/FnPosBridge";

@observer
class CustomerExpectTimeYgyView extends Component {
    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        let time = []
        if(rootStore.viewStore.getOrderDetail.mobileOrderFg == "27"){
            time = ["5", "10", "15", "20", "25","30","40","45","50","60"]
        }else{
            time = ["5","10", "15", "20", "25","30"]
        }

        return (
            <div className={"layer_comm layer_common_type " + (layerStore.getLayerCstExpectTimeYgyView ? ' layer_open' : '')}>
                <div className="bg" />
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>예상 조리시간</h1>
                        </div>
                        <div className={rootStore.viewStore.getOrderDetail.mobileOrderFg == "27" ? "list_radio_time" : "list_radio_time ygy"}>
                            {
                                time.map((arr, index) => (
                                    <label key={index}
                                    ><input type="radio" name="time" checked={(fn_get_customer_ygy_pop(rootStore, "min" + arr) === "Y") ? true : ""}
                                        onChange={event => {
                                            rootStore.layerStore.setChangeCstTime(arr);
                                            rootStore.viewStore.initCustomerPopBtnYgy();
                                            fn_set_customer_ygy_pop(rootStore,  "min" + arr, "ygy");
                                        }
                                        }
                                        /><span className={(!fn_setTimeListDisabled(rootStore, arr) ? "disabled" : "")}>{arr}분</span></label>
                                ))
                            }
                            <div className="wrap_full_btn">
                                <span className="f_l"><button className="btn_cancel"
                                    onClick={event => {
                                        rootStore.layerStore.setLayerAlertType("");
                                        layerStore.setLayerCstExpectTimeYgy(false);
                                    }}
                                >취소</button></span>
                                <span className="f_r"><button className="btn_submit"
                                    onClick={event => {
                                        rootStore.layerStore.setLayerAlertType("");
                                        fn_bridge_order_accept(rootStore, rootStore.viewStore.getOrderDetail.mobileOrderNo, rootStore.layerStore.getChangeCstTime, rootStore.viewStore.getOrderDetail.orderNo)
                                        //fn_change_step(rootStore, '200');
                                    }}
                                >확인</button></span>
                            </div>

                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => {layerStore.setLayerCstExpectTimeYgy(false);rootStore.viewStore.initCustomerPopBtnYgy();}}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerExpectTimeYgyView;